import { createSafeContext } from '@mantine/core';

import { CompareInputContextValue } from './ComparisonInput.types';

const [CompareInputProvider, useCompareInput] = createSafeContext<CompareInputContextValue>(
  'CompareInputProvider is not defined'
);

export { CompareInputProvider, useCompareInput };
